import { useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useReferenceList } from '../../hooks/useReferenceList'
import Autocomplete from '../Autocomplete'

function PersonalStep() {
  const { submitStep } = useAuth()
  const occupations = useReferenceList('occupation')
  const [form, setForm] = useState({
    displayName: '',
    occupation: '',
    company: '',
    location: '',
    bio: '',
  })
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const update = (key) => (event) => {
    setForm({ ...form, [key]: event.target.value })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setSubmitting(true)
    try {
      await submitStep(form)
    } catch (err) {
      setError(err.message)
      setSubmitting(false)
    }
  }

  return (
    <form className="onb-form" onSubmit={handleSubmit}>
      <h1 className="onb-title">Tell us about you</h1>
      <p className="onb-sub">This helps tailor Codetalk to your work.</p>

      {error && <div className="onb-error">{error}</div>}

      <label className="onb-label">
        Display name
        <input className="onb-input" value={form.displayName} onChange={update('displayName')} required />
      </label>

      <label className="onb-label">
        Occupation
        <select className="onb-input" value={form.occupation} onChange={update('occupation')} required>
          <option value="" disabled>
            Select one
          </option>
          {occupations.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </label>

      <label className="onb-label">
        Company / firm
        <Autocomplete
          type="firm"
          value={form.company}
          onChange={(value) => setForm({ ...form, company: value })}
          placeholder="Start typing..."
        />
      </label>

      <label className="onb-label">
        Location
        <input className="onb-input" value={form.location} onChange={update('location')} placeholder="City, State" />
      </label>

      <label className="onb-label">
        Short bio
        <textarea className="onb-input onb-textarea" value={form.bio} onChange={update('bio')} rows={3} />
      </label>

      <button className="onb-submit" type="submit" disabled={submitting}>
        {submitting ? 'Saving...' : 'Continue'}
      </button>
    </form>
  )
}

export default PersonalStep
